import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Layout from './components/Layout';
import Admin from './pages/Admin';
import Home from './pages/Home';
import Projects from './pages/Projects';
import About from './pages/About';
import Contact from './pages/Contact';
import Donate from './pages/Donate';
import Resources from './pages/Resources';
import ProjectDetail from './pages/ProjectDetail';
import ResourceDetail from './pages/ResourceDetail';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes - WITH Navbar & Footer via Layout */}
        <Route path="/" element={<Layout><Home /></Layout>} />
        <Route path="/projects" element={<Layout><Projects /></Layout>} />
        <Route path="/projects/:id" element={<Layout><ProjectDetail /></Layout>} />
        <Route path="/about" element={<Layout><About /></Layout>} />
        <Route path="/contact" element={<Layout><Contact /></Layout>} />
        <Route path="/donate" element={<Layout><Donate /></Layout>} />
        <Route path="/resources" element={<Layout><Resources /></Layout>} />
        <Route path="/resources/:slug" element={<Layout><ResourceDetail /></Layout>} />
        
        {/* Admin Routes - AuthProvider ONLY wraps admin routes */}
        <Route path="/admin/*" element={
          <AuthProvider>
            <Admin />
          </AuthProvider>
        } />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
